'use strict'

import React from 'react';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx'
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import {Organization} from '../Organization.jsx';

import formDefinition from './communicationManagementApproachFormDefinition.js';
import Translations from '../../app/utils/translations.js';

import sendCommand from '../../app/utils/sendCommand.js';

let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

class StakeholdersInDefinition extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general;
    return this.props.project.stakeholderDescription!==undefined && this.props.project.stakeholderDescription!==null && this.props.project.stakeholderDescription.trim().length>0 ? (
      <div>
        <b>{labels.stakeholdersInDefinition}</b>:
        <div>
          {this.props.project.stakeholderDescription}
        </div>
      </div>
    ) : null;
  }
}

export class CommunicationManagementApproach extends React.Component {

    //**** Duplcate start **** Modified duplication of BusinessCase to show detailed lesson
    constructor(props) {
      super(props);
      var selected=0;
      if (typeof window!=="undefined" && window.location.hash.length>0) {
        formDefinition.forEach((area,index) =>{
          if (area.name===window.location.hash.slice(1)) {
            selected=index;
          }
        })
      }
      this.state={
        approach: Object.assign({},props.project.communicationApproach,{
          id: props.project.communicationApproach!==undefined ? "savedApproach" : undefined,
          stakeholders: props.project.stakeholderCommunication!==undefined ? props.project.stakeholderCommunication : [],
          _progress:"stakeholderAnalysis"
        }),
        selected: selected
      };
    }

    showDetails(details) {
      //Allow all tabs to be updated and start on same tab as last save.
      this.setState({
        details:Object.assign({},details,{
          item: Object.assign({},details.item,{_progress:"communication", _currentProgress: details.item.id!==undefined ? details.item._progress : ""})
        })
      });
    }

    updateDetails(content) {
      if (content.id!==undefined) {
        sendCommand({
          type: "updateStakeholderCommunication",
          project: {id: this.props.project.id},
          stakeholder:content
        })
          .then(response=>{
/*
            let approach=Object.assign({},this.state.plan,{
              [this.state.details.field]:this.state.approach[this.state.details.field].map(item=>
                item.id===content.id ? Object.assign({},item,Object.assign({},content,{_progress:"communication"})) : item
              )
            });
*/
            let approach=Object.assign({},this.state.plan,{
              [this.state.details.field]:response.stakeholderCommunication
            });
            this.setState({approach:Object.assign({},approach,{_progress: "stakeholderAnalysis"}), details:content._progress!=="communication" ? Object.assign({},this.state.details,{item:Object.assign({},content,{_progress:"communication",_currentProgress:content._progress})}) : undefined, selected:2, modified:true, modifiedDetails: undefined});
          })
          .catch(error=>{
            console.log("Got error "+JSON.stringify(error),error);
            alert("Could not update stakeholder");
          });
      } else {
        let stakeholderCommunication=Object.assign({},content,{id: uuid.v4()});
        sendCommand({
          type:"identifyStakeholderCommunication",
          project: {id: this.props.project.id},
          stakeholder:stakeholderCommunication
        })
          .then(response=>{
/*
            let approach=Object.assign({},this.state.plan,{
              [this.state.details.field]:this.state.approach[this.state.details.field]
                .concat(Object.assign({},stakeholderCommunication,{_progress:"communication"}))
            });
*/
            let approach=Object.assign({},this.state.plan,{
              [this.state.details.field]:response.stakeholderCommunication
            });

            this.setState({approach:Object.assign({},approach,{_progress: "stakeholderAnalysis"}), details:content._progress!=="communication" ? Object.assign({},this.state.details, {item:Object.assign({},stakeholderCommunication,{_progress:"communication", _currentProgress:content._progress})}) : undefined, selected:2, modified:true, modifiedDetails: undefined});
          })
          .catch(error=>{
            console.log("Got error "+JSON.stringify(error),error);
            alert("Could not save stakeholder");
          });
      }
    }

    canceledDetails() {
      this.setState({details:undefined, selected: 2});
    }

    summary(area) {
      let labels=translations.getTranslation(this.props);
      switch (area) {
        case "teamStructure":
          return (
            <Organization {...this.props}/>
          );
        case "stakeholderAnalysis":
          return (
            <StakeholdersInDefinition {...this.props}/>
          );
        default:
          return (
            <i>{labels[area].description}</i>
          );
      }
    }

    //*** Duplicate end ***

    updateApproach(approach) {
      let updatedApproach=Object.assign({},approach,{stakeholders:undefined,_progress:undefined});
      sendCommand({type:"updateCommunicationManagementApproach", project:{id:this.props.project.id},approach: updatedApproach})
        .then(response=>{
          let emptyApproach={
            process: undefined,
            tools: undefined,
            reporting: undefined,
            timing: undefined,
            roles: undefined
          };
          this.setState({approach: Object.assign({},this.state.approach, emptyApproach, response.approach, {id:"saved"})});
        })
        .catch(error=>{
          console.log("Got error: "+JSON.stringify(error),error);
          alert("Error saving approach.",error);
        });
    }

    handleDetailsChange(fieldName) {
      return (event)=>{
        let details=Object.assign({},this.state.details,{
            item: Object.assign({},this.state.details.item,{[event.target.name]:event.target.value})
          }
        );
        this.setState({
          details: details,
          modifiedDetails:true
        });
      }
    }

    render() {
      let labels=translations.getTranslation(this.props).general;
      return (
        <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
          <div style={{width:1016}}>
  {this.state.details!==undefined ? (
    <AreaForm key="details"
      {...this.props}
      display="tab"
      areas={translations.createTranslatedForm(this.state.details.form,this.props.language,this.props.variant)}
      item={this.state.details.item}
      label={labels.stakeholder}
      onUpdate={this.updateDetails.bind(this)}
      modified={this.state.modifiedDetails}
      onCancel={this.canceledDetails.bind(this)}
      handleFieldChange={this.handleDetailsChange.bind(this)}
    />
  ) : (
            <AreaForm
              {...this.props}
              areas={translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)}
              display="tab"
              item={this.state.approach}
              modified={this.state.modified}
              label={labels.approach}
              selected={this.state.selected}
              summary={this.summary.bind(this)}
              onUpdate={this.updateApproach.bind(this)}
              onAddEntry={this.showDetails.bind(this)}
              onEditEntry={this.showDetails.bind(this)}
              onCancel={()=>window.location="."}
            />
  )}
          </div>
        </div>
      )
    }
}

export default class CommunicationManagementApproachPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <CommunicationManagementApproach {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/organization/Approach.jsx